import Button from '@components/ui/Button';
import Heading from '@components/ui/Heading';
import Tag from '@components/ui/Tag';
import { useTranslation } from 'next-i18next';
import { ProductTagInfo } from '@adapters/prismic/types/productTagInfo';

import styles from './TagInfoModalContent.module.scss';
import { useUI } from '@context/GlobalUIContext';
import { useRouter } from 'next/router';

import { useLocale } from '@hooks/useLocale';
interface TagInfoModalContentProps {
  path?: string;
  productTagInfoBannerData: ProductTagInfo;
  isModal?: boolean;
}

export const TagInfodModalContent = ({
  path,
  productTagInfoBannerData,
  isModal,
}: TagInfoModalContentProps) => {
  const { asPath } = useRouter();
  const locale = useLocale();
  const { tagInfoModalPath } = useUI();
  const { t } = useTranslation('common');
  const {
    tagName,
    tagColour,
    tagInfoBannerTitle,
    tagInfoBannerDescription,
    ctaText,
  } = productTagInfoBannerData;
  const { pdp, collection } = ctaText;
  const tagPath = path || asPath;
  const cta = tagPath?.startsWith(`/${locale}/product/`) ? pdp : collection;
  const link = tagInfoModalPath || cta?.link;

  return (
    <>
      <div className={styles.tag}>
        <Tag
          tagText={tagName || t('product.tag.info.modal.tag.name')}
          colourOverride={tagColour || 'red'}
        />
      </div>
      <Heading semanticLevel="h4" styleLevel="4">
        {tagInfoBannerTitle || t('product.tag.info.modal.header')}
      </Heading>
      <p className={styles.mainText}>
        {tagInfoBannerDescription || t('product.tag.info.modal.mainText')}
      </p>
      {isModal && cta?.text && link && (
        <Button
          type="button"
          variant="primary"
          label={cta?.text || t('product.tag.info.modal.cta.text')}
          size="large"
          className={styles.button}
          href={link}
        />
      )}
    </>
  );
};

export default TagInfodModalContent;
